/**
 * Shared API base URL utility
 * Normalizes API base URLs to prevent double slashes and trailing slash issues
 */

/**
 * Get the normalized API base URL
 * Removes trailing slashes to prevent double slashes when concatenating with endpoints
 * @returns {string} The normalized API base URL
 */
export const getApiBaseUrl = () => {
  const baseUrl = import.meta.env.VITE_API_URL || "http://localhost:8000";
  // Remove trailing slashes to prevent double slashes
  return baseUrl.replace(/\/+$/, "");
};
